<template>
  <div class="year-box">
    <RadioGroup @on-change="getValue" size="small" style="width: 100%" v-model="type">
      <div class="box-bottom">
        <Radio border label="1" size="small">每年</Radio>
      </div>
      <div class="box-bottom">
        <Radio border label="-1" size="small">不指定</Radio>
      </div>
      <div class="box-bottom">
        <Radio border label="2" size="small">周期</Radio>
        <template v-if="type=='2'">
          <span style="margin-right:0.5rem;">从</span>
          <InputNumber
            :min="0"
            @on-change="getChangeYear"
            size="small"
            style="width: 5rem;"
            v-model="cycle.start"
          ></InputNumber>
          <span style="margin:0 0.5rem;">至</span>
          <InputNumber
            :min="parseInt(cycle.start)"
            @on-change="getChangeYear"
            size="small"
            style="width: 5rem;"
            v-model="cycle.end"
          ></InputNumber>
          <span style="margin-left:0.5rem;">年</span>
        </template>
      </div>
    </RadioGroup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: "-1", // 类型
      cycle: {
        // 周期
        start: 2000,
        end: 2020
      },
      // 年份选择结果
      result: ""
    }
  },
  methods: {
    // 当前选择项
    getValue (value) {
      if (value == "-1") {
        // 不指定 年份为空(年份允许为空)
        this.result = " "
      } else if (value == "1") {
        // 指定每年
        this.result = "*"
      } else {
        // 指定年份周期
        this.result = this.cycle.start + "-" + this.cycle.end
      }
      console.log("年result", this.result)
      this.$emit("year", this.result)
    },
    // 选择年份周期
    getChangeYear () {
      this.type = "2"
      this.result = this.cycle.start + "-" + this.cycle.end
      console.log("年result", this.result)
      this.$emit("year", this.result)
    }
  }
};
</script>